// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
Vue.config.productionTip = false
Vue.use(ElementUI);
/* eslint-disable no-new */
axios.defaults.baseURL = "http://localhost:8083";
//axios.defaults.baseURL = "";
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;

//IP地址
if (process.env.NODE_ENV == 'development') { //开发环境
  console.log("开发环境进来了吗")
  axios.defaults.baseURL = process.env.API_HOST;
  console.log( axios.defaults.baseURL)
} else if (process.env.NODE_ENV == 'production') { //线上环境
  axios.defaults.baseURL = process.env.API_HOST;
}

Vue.prototype.$axios = axios
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js